import { render } from "./LtrCalculationFormBasic.vue?vue&type=template&id=1b73fc2d&scoped=true"
import script from "./LtrCalculationFormBasic.vue?vue&type=script&lang=js"
export * from "./LtrCalculationFormBasic.vue?vue&type=script&lang=js"

import "./LtrCalculationFormBasic.vue?vue&type=style&index=0&id=1b73fc2d&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b73fc2d"]])

export default __exports__